export default __webpack_public_path__ + "static/media/lp-sec08_ttl.00ba820c.png";